var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14890_14257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.33337C11.6822 1.33337 14.6668 4.31804 14.6668 8.00004C14.6668 11.682 11.6822 14.6667 8.00016 14.6667C4.31816 14.6667 1.3335 11.682 1.3335 8.00004C1.3335 4.31804 4.31816 1.33337 8.00016 1.33337ZM8.00016 2.66671C6.58567 2.66671 5.22912 3.22861 4.22893 4.2288C3.22873 5.229 2.66683 6.58555 2.66683 8.00004C2.66683 9.41453 3.22873 10.7711 4.22893 11.7713C5.22912 12.7715 6.58567 13.3334 8.00016 13.3334C9.41465 13.3334 10.7712 12.7715 11.7714 11.7713C12.7716 10.7711 13.3335 9.41453 13.3335 8.00004C13.3335 6.58555 12.7716 5.229 11.7714 4.2288C10.7712 3.22861 9.41465 2.66671 8.00016 2.66671ZM8.00016 4.00004C8.16345 4.00006 8.32105 4.06001 8.44308 4.16852C8.5651 4.27702 8.64306 4.42654 8.66216 4.58871L8.66683 4.66671V7.72404L10.4715 9.52871C10.5911 9.64868 10.6605 9.80966 10.6656 9.97896C10.6708 10.1483 10.6114 10.3132 10.4993 10.4402C10.3873 10.5673 10.2311 10.6469 10.0625 10.663C9.8939 10.679 9.72549 10.6303 9.5915 10.5267L9.52883 10.4714L7.52883 8.47137C7.42522 8.36767 7.35867 8.23271 7.3395 8.08737L7.3335 8.00004V4.66671C7.3335 4.4899 7.40373 4.32033 7.52876 4.1953C7.65378 4.07028 7.82335 4.00004 8.00016 4.00004Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14890_14257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.a46458c4bace3205366813c9f6902b04.svg";
export { ForwardRef as ReactComponent };